import {
  getSearchResultPropsForIndex,
  MediocreSearchResultProps,
} from 'notebook/mediocre/search/SearchResultProps';

/**
 * Slices a NoteLinkedGroup's Ctrl-F search-result tree down to the subtree for a single contained
 * table, so the table receives the same shape of search props it would as a standalone note part.
 *
 * The group's `getSearchResults` (see NoteLinkedGroupPlugin) roots each hit under
 * `[groupCid, containedTableCid, ...]`; the editor consumes the leading group cid before threading
 * the tree into the group view, leaving the contained table cid at the root here.
 */
export function getContainedTableSearchResultProps(
  props: Partial<MediocreSearchResultProps>,
  containedNotePartCid: string
): MediocreSearchResultProps {
  return getSearchResultPropsForIndex(
    {
      searchResultsTree: props.searchResultsTree ?? null,
      selectedSearchResultTree: props.selectedSearchResultTree ?? null,
    },
    containedNotePartCid
  );
}
